/**
 * WHAT THIS APPLICATION IS CALLED, IN ONE PLACE.
 *
 * ⚠️ "Flexi Network" IS NOT THIS APPLICATION'S NAME. The application is
 * **Flexi Bot**; Flexi Network is the company that publishes it. Before this
 * file existed the two were used interchangeably, and they had already
 * drifted: `config/index.ts` said "Flexi Network" while the navbar said
 * "Flexi Bot" and bypassed the config entirely.
 *
 * That distinction stops being cosmetic as soon as a customer holds accounts
 * with more than one Flexi application. "Thank you for signing up for Flexi
 * Network" tells a customer nothing about which of Flexi Domains, Flexi Email
 * or Flexi Bot just took their money.
 *
 * ⚠️ IMPORT THESE RATHER THAN TYPING THE NAME. A literal in a component is a
 * copy that drifts: renaming the product then means finding every string in
 * every module, and the ones that are missed are the customer-facing ones
 * nobody reads in review.
 *
 * ⚠️ THE DOCUMENTATION SITE IS A SEPARATE ARTIFACT and cannot import this. A
 * rename has to change both, and the docs half is tracked separately.
 */

/**
 * The application, as a customer should see it named.
 *
 * Use this wherever copy refers to what the product does on a customer's
 * behalf: "Thank you for signing up for PRODUCT_NAME", "PRODUCT_NAME
 * Products".
 */
export const PRODUCT_NAME = 'Flexi Bot';

/**
 * The company that publishes the application.
 *
 * ⚠️ USE THIS ONLY WHERE THE COMPANY IS GENUINELY THE SUBJECT — a legal
 * notice, a corporate "about us" paragraph, a support address shared across
 * products. For anything a customer reads about what this application does,
 * the subject is the application, so use `PRODUCT_NAME`.
 */
export const COMPANY_NAME = 'Flexi Network';
